// extracted by mini-css-extract-plugin
export default {"container":"Jaa-z","tab":"Kaa-z","selected":"Laa-z"};